<template>
  <div>
    <CubePage type="myorder-view" title="供应商订单" :backurl="'supplier'">
      <div slot="content">
        <van-sticky :offset-top="44">
          <van-search
            placeholder="请输入产品名称/订单号/游客/手机号"
            v-model="row.search"
            @search="onSearch"
            show-action
          >
            <div slot="action" @click="onSearch">
              <van-button type="primary">搜索</van-button>
            </div>
          </van-search>
          <van-swipe :loop="false" :width="60" :height="30" :show-indicators="false" style="margin-left:10px;" class="hd">
            <van-swipe-item style="width: auto">
              <van-button
                :class="row.status==''?'van-button-active':''"
                @click="onTagBtn('')"
                plain
                round
                size="mini"
                style="font-size: 12px;"
              >全部</van-button>
            </van-swipe-item>
            <van-swipe-item style="width: auto">
              <van-button
                :class="row.status=='4'?'van-button-active':''"
                @click="onTagBtn('4')"
                plain
                round
                size="mini"
                style="font-size: 12px;"
              >待确认</van-button>
            </van-swipe-item>
            <van-swipe-item style="width: auto">
              <van-button
                :class="row.status=='1'?'van-button-active':''"
                @click="onTagBtn('1')"
                plain
                round
                size="mini"
                style="font-size: 12px;"
              >已支付</van-button>
            </van-swipe-item>
            <van-swipe-item style="width: auto">
              <van-button
                :class="row.status=='2'?'van-button-active':''"
                @click="onTagBtn('2')"
                plain
                round
                size="mini"
                style="font-size: 12px;"
              >已退款</van-button>
            </van-swipe-item>
            <van-swipe-item style="width: auto">
              <van-button
                :class="row.status=='5'?'van-button-active':''"
                @click="onTagBtn('5')"
                plain
                round
                size="mini"
                style="font-size: 12px;"
              >待核销</van-button>
            </van-swipe-item>
            <van-swipe-item style="width: auto">
              <van-button
                :class="row.status=='3'?'van-button-active':''"
                @click="onTagBtn('3')"
                plain
                round
                size="mini"
                style="font-size: 12px;"
              >已核销</van-button>
            </van-swipe-item>
            <van-swipe-item style="width: auto">
              <van-button
                :class="row.status=='6'?'van-button-active':''"
                @click="onTagBtn('6')"
                plain
                round
                size="mini"
                style="font-size: 12px;"
              >待退款</van-button>
            </van-swipe-item>

            <van-swipe-item style="width: auto">
            </van-swipe-item>
          </van-swipe>
          <div class="cal-box">
            <div class="cal-sc">
              <div class="title">使用时间</div>
              <div class="cals" @click="calshow=true">
                <span class="ri" v-if="row.use_date_start">{{row.use_date_start}}</span>
                <span v-else style="color: #9e9e9e; font-size: 12px;">选择开始日期</span>
                <van-icon name="notes-o" size="25"/>
              </div>
              <div class="dj">到</div>
              <div class="cals" @click="calshow=true">
                <span class="ri" v-if="row.use_date_end">{{row.use_date_end}}</span>
                <span v-else style="color: #9e9e9e; font-size: 12px;">选择结束日期</span>
                <van-icon name="notes-o" size="25"/>
              </div>
            </div>
            <van-swipe :loop="false" :width="60" :height="30" :show-indicators="false" style="margin-left:10px;" class="hd">
              <van-swipe-item style="width: auto">
                <van-button
                  :class="selectcaltag=='全部'?'van-button-active':''"
                  @click="onTagCalBtn('全部')"
                  plain
                  round
                  size="mini"
                  style="font-size: 12px;"
                >全部</van-button></van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button
                  :class="selectcaltag=='今天'?'van-button-active':''"
                  @click="onTagCalBtn('今天')"
                  plain
                  round
                  size="mini"
                  style="font-size: 12px;"
                >今天</van-button></van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button
                    :class="selectcaltag=='明天'?'van-button-active':''"
                    @click="onTagCalBtn('明天')"
                    plain
                    round
                    size="mini"
                    style="font-size: 12px;"
                  >明天</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button
                  :class="selectcaltag=='后天'?'van-button-active':''"
                  @click="onTagCalBtn('后天')"
                  plain
                  round
                  size="mini"
                  style="font-size: 12px;"
                >后天</van-button></van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button
                  :class="selectcaltag=='近7天'?'van-button-active':''"
                  @click="onTagCalBtn('近7天')"
                  plain
                  round
                  size="mini"
                  style="font-size: 12px;"
                >近7天</van-button></van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button
                  :class="selectcaltag=='近两周'?'van-button-active':''"
                  @click="onTagCalBtn('近两周')"
                  plain
                  round
                  size="mini"
                  style="font-size: 12px;"
                >近两周</van-button></van-swipe-item>
            </van-swipe>
          </div>
        </van-sticky>

        <div style="z-index: -10;">
          <van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
            <template #image>
              <img src="@/assets/img/empty.png" alt>
            </template>
          </van-empty>
          <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad()"
              :immediate-check="false"
            >
              <div
                class="orderitem van-clearfix"
                v-for="(item,index) in OrderList"
                :key="index"
                @click="goDetail($event,item.id)"
              >
                <div class="ordertitle">
                  <p>订单号：{{item.order_no}}</p>
                  <p class="colorred">
                    <span>{{item.order_status_text}}</span>
                  </p>
                </div>
                <van-card
                  :num="item.total_num"
                  :title="item.goods_name"
                  :thumb="item.goods_image"
                >
                  <template #price-top>
                    <div class="carflex" style="padding: 5px 0;">
                      <div>
                        <div class="carddesc">
                          <span>使用时间：</span>
                          <span>{{item.use_date}}</span>
                        </div>
                        <div class="carddesc">
                          <span>联系人：</span>
                          <span>{{item.contacts}}</span>
                        </div>
                        <div class="carddesc">
                          <span>联系电话：</span>
                          <span>{{item.telephone}}</span>
                        </div>
                        <div class="carddesc">
                          <span>下单时间：</span>
                          <span>{{item.createtime}}</span>
                        </div>
                      </div>
                      <div v-if="item.switch == 1">
                        <div
                          class="btn-div hxbtn"
                          style="height: 20px; line-height: 20px; width: 48px;"
                          @click="goHx(item.id)"
                        >
                          <span>核销</span>
                        </div>
                      </div>
                      <div v-if="item.order_status =='1'">
                        <div
                          class="btn-div zfbtn"
                          style="height: 20px; line-height: 20px; width: 48px;"
                          @click="goJieD(item.id)"
                        >
                          <span>接单</span>
                        </div>
                        <div
                          class="btn-div tkbtn"
                          style="margin-top: 10px;height: 20px; line-height: 20px; width: 48px;"
                          @click="goJuD(item.id)"
                        >
                          <span>拒单</span>
                        </div>
                      </div>
                      <div v-if="item.type =='6'">
                        <div
                            class="btn-div zfbtn"
                            style="height: 20px; line-height: 20px; width: 48px;"
                            @click="goExamine(item.id,'20')"
                        >
                          <span>审核</span>
                        </div>
                        <!-- <div
                          class="btn-div zfbtn"
                          style="height: 20px; line-height: 20px; width: 48px;"
                          @click="goExamine(item.id,'20')"
                        >
                          <span>通过</span>
                        </div>
                        <div
                          class="btn-div tkbtn"
                          style="margin-top: 10px;height: 20px; line-height: 20px; width: 48px;"
                          @click="goExamine(item.id,'30')"
                        >
                          <span>拒绝</span>
                        </div>-->
                      </div>
                    </div>
                  </template>

                  <template #footer>
<!--                    <div class="item">
                      总价¥
                      <span class="price">{{item.total_price}}</span>
                    </div>
                    <div class="item blodspan">
                      实付款¥
                      <span class="price">{{item.pay_price}}</span>
                    </div>-->
                    <div class="item blodspan">
                      总价¥
                      <span class="price">{{item.total_price}}</span>
                    </div>
                  </template>
                </van-card>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </CubePage>
    <cube-view></cube-view>
    <van-calendar
      v-model="calshow"
      type="range"
      @confirm="onConfirm"
      :allow-same-day="true"
      :min-date="minDate"
    />
    <!-- 拒绝订单审核 -->
    <van-action-sheet v-model="actionshow" title="拒绝理由" style="width:100%">
      <div class="contentsheet">
        <van-field
          v-model="messagetext"
          rows="2"
          autosize
          type="textarea"
          maxlength="20"
          placeholder="请填写拒绝理由"
          show-word-limit
        />
        <div class="btnmini" @click="refuseReason">
          <van-button type="info" size="small">确定</van-button>
        </div>
      </div>
    </van-action-sheet>
    <!-- 拒绝退单申请 -->
    <van-action-sheet v-model="refundshow" title="拒绝理由" style="width:100%">
      <div class="contentsheet">
        <van-field
            v-model="refundtext"
            rows="2"
            autosize
            type="textarea"
            maxlength="20"
            placeholder="请填写拒绝理由"
            show-word-limit
        />
        <div class="btnmini" @click="refundExamine(refundid,'30')">
          <van-button type="info" size="small">确定</van-button>
        </div>
      </div>
    </van-action-sheet>
    <van-dialog
      v-model="show"
      title="订单信息"
      show-cancel-button
      confirmButtonText="确认核销"
      :before-close="beforeCloseDis"
    >
      <div class="hxdialog">
        <div class="ordertitle">
          <p>订单号：{{orderData.order_no}}</p>
        </div>
        <van-card :title="orderData.goods_name" style="margin: 0;">
          <template #desc>
            <div class="carddesc">
              <span></span>
              <span>{{orderData.goods_attr}}</span>
            </div>
            <div class="carddesc">
              <span>使用人：</span>
              <span>{{orderData.contacts}}</span>
            </div>
            <div class="carddesc">
              <span>手机号：</span>
              <span>{{orderData.telephone}}</span>
            </div>
            <div class="carddesc">
              <span>证件号：</span>
              <span>{{orderData.IDCard}}</span>
            </div>
            <div class="carddesc">
              <span>核销码：</span>
              <span>{{orderData.code}}</span>
            </div>
            <div class="carddesc">
              <span>订单数：</span>
              <span style="color: #ff0000;">{{orderData.total_num}}份</span>
            </div>
          </template>
          <template #footer>
            <div style=" width: 100%; display: flex; flex-direction: column;">
              <div class="footerflex">
                <div>使用日期：</div>
                <div>{{orderData.use_time}}</div>
              </div>
              <div class="footerflex">
                <span>已核销：</span>
                <span>{{orderData.use_total}}份</span>
              </div>
              <div class="footerflex">
                <span>已退款：</span>
                <span>{{orderData.refund_total}}份</span>
              </div>
              <div class="footerflex">
                <span>已过期：</span>
                <span>{{orderData.over_total}}份</span>
              </div>
              <div class="footerflex">
                <span>可核销：</span>
                <span>{{orderData.no_use_total}}份</span>
              </div>
              <div class="footerflex" v-show="orderData.no_use_total > 0">
                <span style="color: #333;">本次核销：</span>
                <span>
                  <van-stepper
                    v-model="num"
                    theme="round"
                    button-size="22"
                    disable-input
                    :max="orderData.no_use_total"
                  />
                </span>
              </div>
            </div>
          </template>
        </van-card>
      </div>
    </van-dialog>
  </div>
</template>


<script>
import CubeView from "@/components/TP/cube-view";
import CubePage from "../../TP/cube-page.vue";
import * as udate from "@/utils/date";
import * as util from "@/utils/network";

import { Dialog, Toast } from "vant";
export default {
  components: {
    CubePage,
    CubeView
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      OrderList: [],
      isNoData: false,
      gcfg: [],
      pageIndex: 1,
      pageTotal: 0,
      selectcaltag: "",
      calshow: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      row: {
        status: "",
        search: "",
        use_date_start: "",
        use_date_end: ""
      },
      show: false,
      orderData: {},
      num: 0,
      actionshow: false,
      messageid: 0,
      messagetext: "",
      refundshow: false,
      refundid: 0,
      refundtext: ""
    };
  },
  created() {
    this.gcfg = this.$store.getters.getGcfg;
    this.get_my_order();
  },
  methods: {
    beforeCloseDis(action, done) {
      let that = this;
      if (action === "confirm") {
        var url = "/addons/litestore/api.supplier/use_wirteoffcode";

        if (that.num < 1) Toastr.error("已无符合规则核销码");

        //这里直接调用网络接口
        util.post(
          url,
          {
            code: that.orderData.code,
            num: that.num,
            type: "order"
          },
          function(result) {
            Toast.success(result.msg);
            done();
            that.orderno = "";
            that.orderData = {};
          },
          function fail(err) {
            done();
            that.orderno = "";
            that.orderData = {};
          }
        );
      } else {
        done();
        that.orderno = "";
        that.orderData = {};
        that.num = 0;
      }
    },

    //核销按钮
    goHx(id) {
      let that = this;
      var url = "/addons/litestore/api.supplier/get_wirteoffcode";
      //这里直接调用网络接口
      util.post(
        url,
        {
          order_id: id,
          type: "order"
        },
        function(result) {
          that.orderData = result.data;
          that.num = result.data.no_use_total;
          that.show = true;
        }
      );
    },
    //拨打电话
    goPhone(e) {
      window.location.href = "tel://" + e;
    },
    // 跳转详情页
    goDetail(event, id) {
      console.log(event);
      // 阻止a标签跳转
      event.preventDefault();
      if (
        event.target.outerText == "核销" ||
        event.target.outerText == "接单" ||
        event.target.outerText == "拒单" ||
        event.target.outerText == "通过" ||
        event.target.outerText == "拒绝"
      ) {
        return;
      }
      this.$router.push({
        path: "/supplier_orderDetail",
        query: {
          id: id
        }
      });
    },
    //接单
    goJieD(id) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确认要接单操作吗？"
      })
        .then(() => {
          this.beforeClose(id, 0);
        })
        .catch(() => {
          // on cancel
        });
    },
    //拒单
    goJuD(id) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确认要拒单操作吗？"
      })
        .then(() => {
          this.actionshow = true;
          this.messageid = id;
        })
        .catch(() => {
          // on cancel
        });
    },
    //拒单理由
    refuseReason() {
      let message = this.messagetext;
      if (!message) {
        return Toast.fail("拒单理由必须");
      }

      this.beforeClose(this.messageid, -1);
    },
    beforeClose(id, type) {
      let that = this;
      // 拒单
      let param = {
        id: id
      };
      var url = "/addons/litestore/api.supplier/orderRefuse";
      if (type == 0) {
        //接单
        url = "/addons/litestore/api.supplier/orderTaking";
      } else {
        param.emo = this.messagetext;
      }
      //这里直接调用网络接口
      util.post(url, param, function(result) {
        console.log(result);
        if (result.code == 1 || result.code == 200) {
          console.log(result.msg);
          that.$toast.success({
            message: result.msg,
            duration: 800,
            onClose: function() {
              location.reload();
            }
          });
        }
      });
    },
    //退款审核
    goExamine(id,status) {

      util.redirect('supplier_orderTD');

      this.$router.push({
        path: "/supplier_orderTD"
      });

      /*var msg =  status=='20' ? '通过' : '拒绝';
      Dialog.confirm({
        title: "温馨提示",
        message: "是否确认" + msg + "退款申请？"
      })
          .then(() => {
            if (status == '20'){
              this.refundExamine(id, status);
            }
            else {
              this.refundshow = true;
              this.refundid = id;
            }

          })
          .catch(() => {
            // on cancel
          });*/
    },
    refundExamine(id, status) {

      let that = this;
      var url = "/addons/litestore/api.supplier/refundExamine";
      let param = {
        id: id,
        status: status,
      };
      if (status == '30'){
        let message = this.refundtext;
        if (!message) {
          return Toast.fail("拒绝理由必须");
        }
        param.emo = this.refundtext;
      }

      //这里直接调用网络接口
      util.post(url, param, function(result) {
        console.log(result);
        if (result.code == 1 || result.code == 200) {
          console.log(result.msg);
          that.$toast.success({
            message: result.msg,
            duration: 800,
            onClose: function() {
              location.reload();
            }
          });
        }
      });
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      let that = this;
      that.clearContainer();
      const [start, end] = date;
      that.calshow = false;
      that.row.use_date_start = that.formatDate(start);
      that.row.use_date_end = that.formatDate(end);
      that.get_my_order();
    },
    onTagCalBtn(v) {
      let that = this;
      if (that.selectcaltag == v) {
        return;
      }
      this.clearContainer();
      let start = "";
      let end = "";
      let fmt = "yyyy/MM/dd";
      start = udate.getDatenow(fmt);
      switch (v) {
        case "今天":
          end = that.GetDateStr(0, fmt);
          break;
        case "明天":
          start = that.GetDateStr(1, fmt);
          end = that.GetDateStr(1, fmt);
          break;
        case "近7天":
          end = that.GetDateStr(7, fmt);
          break;
        case "后天":
          start = that.GetDateStr(2, fmt);
          end = that.GetDateStr(2, fmt);
          break;
        case "近两周":
          end = that.GetDateStr(14, fmt);
          break;
        case "全部":
          end = "";
          start = "";
          break;
        default:
          end = "";
          break;
      }
      that.row.use_date_start = start;
      that.row.use_date_end = end;
      that.selectcaltag = v;
      that.get_my_order();
    },
    onTagBtn(v) {
      let that = this;
      if (that.row.status == v) {
        return;
      }
      that.row.status = v;
      that.onSearch();
    },
    onSearch() {
      this.clearContainer();
      this.pageIndex = 1;
      this.get_my_order();
    },
    // 上滑加载更多
    onLoad() {
      let that = this;
      // 异步更新数据
      setTimeout(() => {
        that.pageIndex++;
        if (that.OrderList < 1 || that.finished) return;
        if (that.refreshing) {
          that.OrderList = [];
          that.pageIndex = 1;
          that.refreshing = false;
        }
        that.get_my_order();
      }, 1000);
    },
    // 获取数据
    get_my_order() {
      var url = "/addons/litestore/api.supplier/orderList";
      let that = this;
      that.loading = true;
      that.row.page = that.pageIndex;
      //console.log(that.row)
      //这里直接调用网络接口
      util.post(url, that.row, function(result) {
        //这里对状态 进行分类
        that.pageTotal = result.data.total;
        console.log(that.pageTotal, "1111111111");
        if (that.pageTotal < 1) {
          // that.finished = true;
          that.isNoData = true;
          return;
        } else {
          that.isNoData = false;
        }
        that.loading = false;
        if (result.data.list == null || result.data.list.length === 0) {
          // 加载结束
          that.finished = true;
          return;
        }
        // 将新数据与老数据进行合并
        that.OrderList = that.OrderList.concat(result.data.list);
        console.log(that.OrderList, "2222222222222");
        // console.log(that.isNoData)
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.OrderList.length >= that.pageTotal) {
          that.finished = true;
        }
      });
    },
    GetDateStr(AddDayCount) {
      var day = new Date();
      day.setDate(day.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = day.getFullYear();
      var m = day.getMonth() + 1; //获取当前月份的日期
      var d = day.getDate();
      m = String(m < 10 ? "0" + m : m);
      d = String(d < 10 ? "0" + d : d);
      let beg = y + "/" + m + "/" + d;

      return y + "/" + m + "/" + d;
    }, // 初始化数据
    clearContainer() {
      let that = this;
      that.loading = false;
      that.finished = false;
      that.refreshing = false;
      that.OrderList = [];
      that.isNoData = false;
      that.pageIndex = 1;
      that.pageTotal = 0;
    },
    //下拉刷新
    onRefresh() {
      this.finished = false;
      this.onLoad();
    }
  }
};
</script>
<style lang="less" type="text/css">
.van-sticky {
  background: #fafafa !important;
}
</style>
<style lang="less" scoped="scoped">
@import url("../../../assets/css/order.css");
@import url("../../../assets/css/listboxless.less");

.van-search {
  .van-search__action {
    line-height: 0;
  }

  .van-button {
    height: 34px;
  }
}

.hd {
//   background-color: #ffffff;
//   width: 100%;
//   overflow: scroll;
//   padding-bottom: 10px;
//   box-sizing: border-box;

//   .tags {
//     margin: 0 10px;
//     box-sizing: border-box;
//     display: flex;
    .van-button {
      flex-shrink: 0;
      margin-right: 6px;
    }

    .van-button-active {
      border: 1px solid #55aa7f;
      color: #55aa7f;
    }
//   }
}

.van-button--mini {
  padding: 0 10px !important;
}

// .van-sticky {
// z-index: 999999;
// background-color: #fff;

.cal-box {
  background-color: #ffffff;
}

.cal-sc {
  margin-top: 10px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  .title {
    color: #989898;
    padding-right: 10px;
  }

  .dj {
    margin: 0 5px;
  }

  .cals {
    .ri {
      font-weight: 600;
    }

    .van-icon {
      color: #55aa7f;
      margin-left: 10px;
      vertical-align: middle;
    }
  }

  // }
}

.footerflex {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 0;
  color: #ff0000;
  font-size: 14px;
}

.hxdialog {
  border-bottom: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;

  // margin-top: 10px;
  // padding: 0 10px;
  .van-card__title {
    font-size: 15px;
    padding-bottom: 5px;
  }

  .carddesc,
  .van-card__num {
    font-size: 13px;
    padding: 3px 0;
  }
}

.contentsheet {
  padding: 16px 16px 20px;
  margin: 0;

  .btnmini {
    width: 100%;
    text-align: right;
    padding-top: 16px;

    .van-button--small {
      width: 70px;
    }
  }
}

</style>
<style type="text/css" lang="less"  scoped="scoped">
.van-card {
  background: transparent !important;
}
.slide {
  overflow-x: auto;
  white-space: nowrap;
  box-sizing: border-box;

  .slide-item {
    display: inline-block;
    width: 100px;
    height: 100px;
    background-color: #ccc;
    margin-right: 10px;
  }
}
</style>
